/**
 * Buffer в браузере — до всего остального.
 *
 * Отдельным модулем и первым импортом намеренно. В ES-модулях всё, что
 * импортировано, выполняется ДО тела файла: присваивание в main.tsx
 * происходило уже после того, как библиотеки TON тронули Buffer на загрузке,
 * и приложение падало с «Can't find variable: Buffer» — заставка висела, а
 * причина была на строке, до которой дело не доходило.
 *
 * Импорт этого модуля первым гарантирует порядок: сначала его тело, потом
 * всё, что импортировано ниже.
 */

import { Buffer } from 'buffer';

const g = globalThis as { Buffer?: typeof Buffer };
g.Buffer ??= Buffer;
